import { Box } from "@mui/material";
import ReturnMedicine from "../components/return-item/returnMedicine";
const ReturnItem = () => {
  return (
    <>
      {/* <Box sx={{ p: 3, fontSize: "24px", fontWeight: "bold" }}>
       Return Item
      </Box> */}
      <Box
        sx={{
          margin: 1,
          backgroundColor: "white",
          // marginTop: "2px",
          // padding: "8px",
          borderRadius: "5px",
          minHeight: {
            xs: "auto",  
            sm: "80vh",  
           
          },
          my: "1.2%",
        }}
      >
        <ReturnMedicine />
      </Box>
    </>
  );
};

export default ReturnItem;


